import { createApp } from "vue";
import App from "@/modules/Quickform/App.vue";
import eventbusPlugin from "@/plugins/eventbus";
import { pinia } from "~/store";
import { VueQueryPlugin } from "@tanstack/vue-query";

import "@/assets/style/style.scss";

const app = createApp(App);

app.use(pinia);
app.use(VueQueryPlugin);
app.use(eventbusPlugin);

app.mount("#quickform");
